import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'

import { createActionButtonNode } from '../../utils/functions'
import { CreateDefaultComponent } from './CreateDefaultComponent'

export class GetStartedComponent extends CreateDefaultComponent {
  async setupDefaultComponent() {
    const component = App.components.get(CONST_COMPONENT.POSTBACK)
    if (! component) {
      throw new Error(`Could not set up '${CONST_COMPONENT.POSTBACK}' component as default`)
    }

    App.defaultComponentName = CONST_COMPONENT.POSTBACK
    App.isDefaultComponentRegistered = true    

    const postbackComponentInstance = new component(App.config)
    const postbackNode = await postbackComponentInstance.createNode()
    postbackNode.position = [-200, -50]

    App.editor.addNode(postbackNode)
    App.defaultComponent = postbackNode

    const actionButtonNode = await createActionButtonNode()
    actionButtonNode.position = [-450, -50]
  
    App.editor.addNode(actionButtonNode)
  
    App.editor.connect(
      actionButtonNode.outputs.get(CONST_SOCKET.ACTION_BUTTON_OUTPUT),
      postbackNode.inputs.get(CONST_SOCKET.REFERENCE_INPUT_ACTION_BUTTON)
    )

    const defaultData = {
      selectedAction: this.params.action,
    }

    App.handleNodeData(actionButtonNode, App.editor, defaultData)
  }
}